// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={(theme) => ({
        '*': {
          boxSizing: 'border-box',
        },

        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },

        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,

          // Phone input styles
          '.react-tel-input .special-label': {
            display: 'none !important',
          },

          '.react-tel-input .form-control': {
            cursor: 'default',
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderColor: theme.palette.divider,
          },

          '.react-tel-input :disabled': {
            borderColor: theme.palette.divider,
            color: theme.palette.text.disabled,
          },

          '.react-tel-input :disabled:hover': {
            borderColor: theme.palette.divider,
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },

        '#root': {
          width: '100%',
          height: '100%',
        },

        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },

        img: {
          display: 'block',
          maxWidth: '100%',
        },

        ul: {
          margin: 0,
          padding: 0,
        },
      })}
    />
  );

  return inputGlobalStyles;
}
